<template>
  <div>
    <div class="lf eventLevel w326 ml">
      <div class="inner-wrap">
        <div class="argument-warp">
          <div id="myCharteventLevel" style="width:100%;height:100%;"></div>
        </div>
      </div>
      <title-h3 :titlemsg="titlemsg"></title-h3>
    </div>
  </div>

</template>

<script>
  import title from '../title'
  export default{
    name:'eventLevel',
    data(){
      return{
        titlemsg:'入驻增长趋势'
      }
    },
    mounted(){
      this.drawLine();
    },
    methods: {
      drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myCharteventLevel'));
        // 绘制图表
        // 指定图表的配置项和数据

         var option = {
            tooltip : {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
            },
            legend: {
              data:['多服务','多商户','七月居多','2022年'],
              textStyle:{ //图例字体颜色
                color:'#fff'
              },
              top:'4%'
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis : [
              {
                type : 'category',
                boundaryGap : false,
                axisLabel: {
//              inside: true,
                  textStyle: {
                    color: '#fff'
                  }
                },
                axisTick: {
                  show: false
                },
                axisLine: {
                  show: true,
                  lineStyle:{
                    color:'#637eaf'
                  }
                },
                data : ['2017','2018','2019','2020','2021','2022']
              }
            ],
            yAxis : [
              {
                type: 'value',
                splitLine:{
                  lineStyle:{
                    type:'dashed',
                    color:['#475e8f']  //网格线虚线
                  }
                },
                axisLine: {
                  show: true,
                  lineStyle:{
                    color:'#637eaf'
                  }
                },
                axisTick: {
                  show: false
                },
                axisLabel: {
                  textStyle: {
                    color: '#fff'
                  }
                }
              }
            ],
            series : [
              {
                name:'一级处置',
                type:'line',
                stack: '总量',
                areaStyle: {normal: {}},
                data:[20, 182, 91, 234, 90, 30, 30]
              },
              {
                name:'二级处置',
                type:'line',
                stack: '总量',
                areaStyle: {normal: {}},
                data:[10, 32, 21, 14, 10, 30, 40]
              },
              {
                name:'三级处置',
                type:'line',
                stack: '总量',
                areaStyle: {normal: {}},
                data:[30, 32, 18, 34, 90, 30, 20]
              },
              {
                name:'四级处置',
                type:'line',
                stack: '总量',
                label: {
                  normal: {
                    show: true,
                    position: 'top'
                  }
                },
                areaStyle: {normal: {}},
                data:[20, 32, 90, 93, 90, 130, 132]
              }
            ],
            color:['#e86c67','#2a97e9','#d8b93e','#b26ee4',]

          };

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      }
    },
    components:{
      'title-h3':title
    }
  }

</script>

<style scoped>
  .eventLevel{width: 40%;height:4.14rem;}
  .eventLevel .inner-wrap{height: 40vh; width: 100%;border-radius: 4px;padding-top: .08rem;overflow:hidden}
  /* height: 3.54rem; */
  .eventLevel .argument-warp{width: 100%;height: 100%;margin: 0 auto;border-radius: 4px;}
  .w326{width:32.604%}
</style>



// WEBPACK FOOTER //
// src/components/emergencyManage/eventLevel.vue